import RouteDemandeLoginOublie from './demande/routes';
import RouteQuestionsLoginOublie from './questions/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesRecuperationLogin = initSubRoutes({
    route: '/recuperer-login',
    subroutes: {
        demande: RouteDemandeLoginOublie,
        questions: RouteQuestionsLoginOublie,
    },
    nom: 'Récupération de login',
});

export default RoutesRecuperationLogin;
